<template>
	<div class="password-container">
		<span :title="password" class="password" :class="{'isHidden': !visible}">{{password}}</span>
		<t-icon-button
			:icon="icon"
			type="bp"
			appearance="minimal"
			disableBoxShadow
			@click="visible = !visible"
		/>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			type: [String, Number],
			default: '',
		}
	},
	data() {
		return {
			visible: false
		};
	},
	computed: {
		password() {
			return this.visible ? this.value : this.value.replace(/./g, '•');
		},
		icon() {
			return this.visible ? 'eye-off' : 'eye-open';
		}
	}
};
</script>

<style lang="scss">
.password-container {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.password {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	&.isHidden {
		user-select: none;
		font-weight: 800;
		letter-spacing: 1.3px;
	}
}
</style>
<docs>
## Examples

```jsx
	<t-password value="Password123456789" style="width:200px;"/>
```
</docs>